// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakePreferencesModel {
    static getAttributeTypeMap() {
        return SimpleIntakePreferencesModel.attributeTypeMap;
    }
}
SimpleIntakePreferencesModel.discriminator = undefined;
SimpleIntakePreferencesModel.additionalProperties = false;
SimpleIntakePreferencesModel.attributeTypeMap = [
    {
        "name": "optIns",
        "baseName": "optIns",
        "type": "SimpleIntakeOptInsModel"
    },
    {
        "name": "preferred",
        "baseName": "preferred",
        "type": "ContactInfoType"
    },
];
//# sourceMappingURL=simpleIntakePreferencesModel.js.map